export class Megamenu extends HTMLElement {
	dialog: HTMLDialogElement;
	content: Element | null | undefined;
	main: Element | null | undefined;
	footer: Element | null | undefined;

	constructor() {
		super();

		const dialog = document.createElement("dialog");
		dialog.setAttribute("id", "megamenu-dialog");
		dialog.setAttribute("closedby", "closerequest");
		dialog.classList.add(
			"w-full",
			"absolute",
			"top-0",
			"min-h-56",
			"bg-white",
			"pt-5",
			"pb-8",
			"shadow-sm",
			"transition-[opacity,translate]",
			"ease-out",
			"motion-safe:starting:open:opacity-0",
			"motion-safe:starting:open:-translate-y-full",
			"open:duration-250",
			"open:opacity-100",
			"open:translate-y-0",
		);

		this.dialog = dialog;
	}

	connectedCallback() {
		this.content = document.querySelector("#content");
		this.main = this.content?.querySelector("main");
		this.footer = this.content?.querySelector("footer");

		const triggers = this.querySelectorAll("button[slot='trigger']");

		this.dialog.addEventListener("toggle", (event) => {
			if (event.newState === "open") {
				this.main?.setAttribute("inert", "");
				this.footer?.setAttribute("inert", "");
			} else {
				this.main?.removeAttribute("inert");
				this.footer?.removeAttribute("inert");

				for (const trigger of triggers) {
					trigger.setAttribute("aria-expanded", "false");
				}
			}
		});

		this.content?.append(this.dialog);

		for (const trigger of triggers) {
			trigger.addEventListener("click", () => {
				const expandedTrigger = this.querySelector(
					"button[aria-expanded='true']",
				);
				const itemContent = trigger.nextElementSibling?.cloneNode(true);

				if (this.dialog.open) {
					if (trigger.isEqualNode(expandedTrigger)) {
						this.dialog.close();
					} else {
						this.dialog.replaceChildren(itemContent ?? "");
						expandedTrigger?.setAttribute("aria-expanded", "false");
						trigger.setAttribute("aria-expanded", "true");
					}
				} else {
					this.dialog.replaceChildren(itemContent ?? "");
					this.dialog.show();
					trigger.setAttribute("aria-expanded", "true");
				}
			});
		}
	}
}
